import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})

/**
 * Invoice component - handling the invoice with navbar and content
 */
export class InvoiceComponent implements OnInit {

  // bread crumb data
  breadCrumbItems: Array<any>;

  constructor() { }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'Extras', path: '/' }, { label: 'Invoice', path: '/', active: true }];

  }

}
